module.exports = __webpack_public_path__ + "static/media/hab4-1.21aeb00b.jpg";